import { underwritingDocExpirationSettingsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOC_EXPIRATION_SETTINGS_ACTION_TYPE = createNamedActions(
  'underwritingDocExpirationSettings',
  {
    GET_SETTINGS: 'GET_SETTINGS',
    EDIT_SETTING: 'EDIT_SETTING',
  },
);

const settingsSchema = new schema.Entity('data', {}, { idAttribute: 'documentExpirationDateType' });

export const getUnderwritingDocExpirationSettingsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await underwritingDocExpirationSettingsApi.getUnderwritingSettings(params);

    dispatch({
      type: DOC_EXPIRATION_SETTINGS_ACTION_TYPE.GET_SETTINGS,
      payload: normalize(data, [settingsSchema]).entities.data,
    });
  },
);

export const editUnderwritingDocExpirationSettingsAction = catchAsyncActionError(
  body => async dispatch => {
    await underwritingDocExpirationSettingsApi.editUnderwritingSettings([body]);

    return dispatch({
      type: DOC_EXPIRATION_SETTINGS_ACTION_TYPE.EDIT_SETTING,
      payload: body,
    });
  },
);
